import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion, useInView } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageCTA from "@/components/PageCTA";
import { HERO_BG_STYLE } from "@/components/heroBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const categories = [
  { key: "all", label: "Wszystkie" },
  { key: "Strony WWW", label: "Strony WWW" },
  { key: "Logo", label: "Logo" },
  { key: "Grafiki", label: "Grafiki" },
  { key: "Materiały", label: "Materiały" },
  { key: "Druk", label: "Druk" },
];

const Realizacje = () => {
  const [portfolio, setPortfolio] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("all");

  useEffect(() => {
    axios.get(`${API}/portfolio`, {
      params: activeCategory !== "all" ? { category: activeCategory } : {}
    }).then(res => {
      setPortfolio(res.data);
      setLoading(false);
    });
  }, [activeCategory]);

  return (
    <div className="min-h-screen" data-testid="realizacje-page">
      <div className="subpage-hero subpage-hero--bg flex items-end" style={HERO_BG_STYLE}>
        <div className="container pb-0">
          <p className="eyebrow mb-4">Nasze realizacje</p>
          <h1 className="font-heading text-[clamp(40px,5vw,58px)] text-[var(--color-text-light)] mb-4">
            Portfolio
          </h1>
          <p className="lead max-w-xl">
            Zobacz wybrane projekty stron, grafik, logo i materiałów reklamowych przygotowanych dla hodowli i marek.
          </p>
        </div>
      </div>

      <div className="section bg-[var(--color-cream)]">
        <div className="container">
          <div className="flex flex-wrap gap-3 mb-12">
            {categories.map((cat) => (
              <button
                key={cat.key}
                onClick={() => setActiveCategory(cat.key)}
                className={`text-xs font-body font-semibold uppercase tracking-wider py-2.5 px-5 rounded-sm border transition-all ${
                  activeCategory === cat.key
                    ? "border-[var(--color-gold)] text-[var(--color-gold)] bg-[var(--color-gold)]/10"
                    : "border-[var(--color-border-light)] text-[var(--color-text-muted)] hover:text-[var(--color-text-dark)] hover:border-[var(--color-gold)]"
                }`}
                data-testid={`filter-${cat.key}`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {loading
              ? [...Array(6)].map((_, i) => (
                  <div key={i} className="aspect-[4/3] bg-[var(--color-white)] rounded animate-pulse border border-[var(--color-border-light)]" />
                ))
              : portfolio.map((item, idx) => (
                  <motion.div
                    key={item.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.05 }}
                    className="group"
                    data-testid={`portfolio-item-${idx}`}
                  >
                    <div className="product-card">
                      <div className="aspect-[4/3] bg-[var(--color-cream)] overflow-hidden">
                        <img
                          src={item.image_url}
                          alt={item.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-5 flex justify-between items-start">
                        <div>
                          <h3 className="font-heading text-xl font-medium text-[var(--color-text-dark)] group-hover:text-[var(--color-gold)] transition-colors">
                            {item.title}
                          </h3>
                          <p className="text-xs font-body text-[var(--color-text-muted)] mt-1">
                            {item.tags?.slice(0, 3).join(" · ")}
                          </p>
                        </div>
                        {item.link && (
                          <a href={item.link} target="_blank" rel="noopener noreferrer">
                            <ArrowUpRight className="w-5 h-5 text-[var(--color-text-muted)] group-hover:text-[var(--color-gold)] transition-colors" />
                          </a>
                        )}
                      </div>
                    </div>
                  </motion.div>
                ))}
          </div>
        </div>
      </div>
      <PageCTA />
    </div>
  );
};

export default Realizacje;
